/* @flow strict */

import * as React from 'react';
// import TimezonePicker from 'react-timezone';
import { timezones } from '/client/src/oldSrc/jstz';
import SimpleSelect from '/client/src/components/forms/select';
import { getTzStar } from "/client/src/utils/jstz";
import moment from 'moment-timezone/builds/moment-timezone-with-data';
import _ from 'lodash';

type PropsType = {
  value: string,
  onChange: (string) => void
};

const EventTimeZone = ({ value, onChange }: PropsType): React.Element<'div'> => {
  const _tz = _.map(timezones, (tz: {}): {} => {
    return {
      value: tz.id,
      label: tz.name
    };
  });

  return (
    <div
      className="form-group SimpleInput timezoneSelect"
      onBlur={(e: any): any => {
        const el = e.target;

        el.parentNode.parentNode.style.zIndex = 9;
      }}
      onFocus={(e: any): any => {
        const el = e.target;

        el.parentNode.parentNode.style.zIndex = 99999;
      }}
    >
      <label htmlFor="timeZone">Time Zone (required)</label>

      <SimpleSelect
        validator={{}}
        items={_tz}
        value={value}
        callBack={(e: any) => {
          onChange({
            target: {
              value: e.target.value,
              name: 'time_zone_id'
            }
          });
        }}
      />

      {/* <TimezonePicker*/}
        {/* value={value}*/}
        {/* onChange={(timezone: string) => {*/}
          {/* onChange({*/}
            {/* target: {*/}
              {/* value: timezone,*/}
              {/* name: 'time_zone_id'*/}
            {/* }*/}
          {/* });*/}
        {/* }}*/}
        {/* inputProps={{*/}
          {/* placeholder: 'Select Timezone...',*/}
          {/* name: 'time_zone_id'*/}
        {/* }}*/}
      {/* />*/}
    </div>
  );
};

export default EventTimeZone;
